import { createApi } from "@reduxjs/toolkit/query/react";
import CustomFetchBase from "../CustomFetchBase";

export const TestimonialApi = createApi({
  reducerPath: "TestimonialApi",
  baseQuery: CustomFetchBase,
  tagTypes: ["TESTIMONIALAPI"],
  endpoints: (build) => ({
    getTestimonial: build.query({
      query: ({ page, searchTerm }) => ({
        url: `/testimonials?page=${page}&search=${searchTerm}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      providesTags: ["TESTIMONIALAPI"],
    }),

    getTestimonialById: build.query({
      query: ({ id }) => ({
        url: `/testimonials/${id}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      providesTags: ["TESTIMONIALAPI"],
    }),

    editTestimonial: build.mutation({
      query: ({ id, data }) => ({
        url: `/testimonials/${id}`,
        method: "PUT",
        body: data,
        headers: {},
      }),
      invalidatesTags: ["TESTIMONIALAPI"],
    }),

    addTestimonial: build.mutation({
      query: ({ data }) => ({
        url: `/testimonials`,
        method: "POST",
        body: data,
        headers: {},
      }),
      invalidatesTags: ["TESTIMONIALAPI"],
    }),

    deleteTestimonial: build.mutation({
      query: ({ id }) => ({
        url: `/testimonials/${id}`,
        method: "DELETE",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      invalidatesTags: ["TESTIMONIALAPI"],
    }),
  }),
});

export const {
  useGetTestimonialQuery,
  useGetTestimonialByIdQuery,
  useEditTestimonialMutation,
  useAddTestimonialMutation,
  useDeleteTestimonialMutation,
} = TestimonialApi;
